import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {closeMap, openMap} from '../../../actionCreators';

import Toggle from './Toggle';

const CloseLabel = gettext('Hide Map');
const OpenLabel = gettext('Show Map');

const Wrapper = ({closed, onClick}) => (
    <Toggle
        label={closed ? OpenLabel : CloseLabel}
        onClick={onClick}
    />
);

const mapDispatchToProps = (dispatch, {closed}) => ({
    onClick: () => dispatch((closed ? openMap : closeMap)()),
});

export default connect(undefined, mapDispatchToProps)(Wrapper);
